import * as miljokontrollActions from "../actions/miljokontrollerActions";

const INITIAL_STATE = {};

export default function miljoKontrollerThumbnailBilderReducer(
  state = { ...INITIAL_STATE },
  action,
) {
  switch (action.type) {
    case miljokontrollActions.GET_MILJOKONTROLL_THUMBNAIL_BILDER_SUCCESS:
      return {
        ...state,
        [action.payload.miljokontrollId]: action.payload.bilder,
      };
    default:
      return state;
  }
}
